module.exports = __webpack_public_path__ + "img/grzj.a9f9e215.webp";